import { BaseService } from './base-service'
import { service } from './base-service'
import qs from 'querystring'
import {
  downloadData,
  extractFileNameFromContentDisposition
} from './utils-service'

class EcosystemService extends BaseService {
  constructor() {
    super('/ecosystem')
  }

  getByName = (name) => {
    return service.get(`/ecosystem/by_name/${name}`)
  }

  getByClient = (client) => {
    return service.get(`/ecosystem/by_client/${client}`)
  }

  getByClientForConfigUser = (client) => {
    return service.get(`/ecosystem/by_client_for_config_user/${client}`)
  }

  getByUserAndClient = (user, client) => {
    const query = qs.stringify({ user, client })
    return service.get(`/ecosystem/by_user_client?${query}`)
  }

  getClosingDates(ecosystemId, filters = {}) {
    const search = new URLSearchParams(filters)
    return service.get(
      `/ecosystem/${ecosystemId}/closing-dates?${search.toString()}`
    )
  }

  getClosingDatesHistory(ecosystemId, filters = {}) {
    const search = new URLSearchParams({
      page: filters.page,
      limit: filters.limit
    })

    if (filters.competenceYear) {
      search.set('competenceYear', filters.competenceYear)
    }

    if (filters.competenceMonth) {
      search.set('competenceMonth', filters.competenceMonth)
    }

    return service.get(
      `/ecosystem/${ecosystemId}/closing-dates-history?${search.toString()}`
    )
  }

  async exportClosingDatesHistory(ecosystemId, filters = {}) {
    const search = new URLSearchParams({ exportType: 'excel' })

    if (filters.competenceYear) {
      search.set('competenceYear', filters.competenceYear)
    }

    if (filters.competenceMonth) {
      search.set('competenceMonth', filters.competenceMonth)
    }

    const response = await service.get(
      `/ecosystem/${ecosystemId}/closing-dates-history?${search.toString()}`,
      {
        responseType: 'blob'
      }
    )

    const fileName = extractFileNameFromContentDisposition(
      response.headers['content-disposition']
    )

    downloadData(
      response.data,
      fileName,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    )
  }

  saveClosingDate({
    ecosystemId,
    closingDate,
    competenceYear,
    competenceMonth,
    observation
  }) {
    return service.put(`/ecosystem/${ecosystemId}/closing-dates`, {
      competenceYear,
      competenceMonth,
      closingDate,
      observation
    })
  }

  checkClosingStatus(unities, date) {
    const params = new URLSearchParams()
    unities.forEach((u) => params.append('unities[]', u))
    params.append('date', date)
    return service.get(`/ecosystem/check-closing-status?${params.toString()}`)
  }

  getUnitiesByEcosystemId(ecosystemId) {
    return service.get(`/ecosystem/${ecosystemId}/unities`)
  }
}

export const ecosystemService = new EcosystemService()
